import React from 'react';
import logo from '../images/ttms_logo_1.png';
import { FaHeart, FaEnvelope, FaTools } from 'react-icons/fa';
import './Footer.css';

const Footer = () => (
    <footer className="ttms-footer">
        <div className="container-fluid ttms-footer-inner">

            <div className="ttms-footer-links">
                <a href="mailto:admin@tripletrans.ca" className="ttms-footer-link">
                    <FaEnvelope size={14} />
                    Triple Trans Mill Services Ltd.
                </a>
                <span className="ttms-footer-divider" />
                <a href="mailto:admin@devify.ca" className="ttms-footer-link">
                    <FaTools size={14} />
                    Developreneurs Tech Limited
                </a>
            </div>

            <div className="ttms-footer-credit">
                Developed with <FaHeart color="#f87171" style={{ margin: '0 3px', verticalAlign: 'middle' }} /> by{' '}
                <span className="ttms-footer-credit-name">Developreneurs Tech Limited</span>
            </div>

            <div>
                <img
                    src={logo}
                    alt="Triple Trans Mill Services Ltd."
                    className="ttms-footer-logo"
                />
            </div>

        </div>
    </footer>
);

export default Footer;
